import { EpimsBaseEntityDto } from './epim-base.dto';
export class ProgramDto extends EpimsBaseEntityDto {
    ProgramName: string;
}